import { SERVICE_NAME } from "@/config/serviceNames";
import { EntityType, Module } from "@/constants";
import { requests } from ".";

interface CreateFileParams {
  name: string;
  contentType: string;
  parentId: string;
  altType: string;
  altId: string;
  size: number;
  mode: string;
}

interface VerifyFileParams {
  altType: string;
  altId: string;
  id: string;
}

interface RenameFileParams {
  name: string;
  altId: string;
  altType: string;
}

interface CreateFolderParams {
  name: string;
  parentId: string;
  altId: string;
  altType: string;
  mode: string;
}

interface GetFoldersParams {
  altId: string;
  altType?: string;
}

const ScreenRecorderMediaService = {
  createFile: (params: CreateFileParams) =>
    requests(SERVICE_NAME.MEDIAS_API)
      .log({
        module: Module.RECORDINGS,
        entityType: EntityType.LOCATION,
        entityId: params.altId,
      })
      .post("files", params),

  verifyFile: (params: VerifyFileParams) =>
    requests(SERVICE_NAME.MEDIAS_API)
      .log({
        module: Module.RECORDINGS,
        entityType: EntityType.LOCATION,
        entityId: params.altId,
      })
      .post("files/verify", params),

  renameFile: (fileId: string, params: RenameFileParams) =>
    requests(SERVICE_NAME.MEDIAS_API)
      .log({
        module: Module.RECORDINGS,
        entityType: EntityType.LOCATION,
        entityId: params.altId,
        documentId: fileId,
      })
      .post(`${fileId}`, params),

  createFolder: (params: CreateFolderParams) =>
    requests(SERVICE_NAME.MEDIAS_API)
      .log({
        module: Module.RECORDINGS,
        entityType: EntityType.LOCATION,
        entityId: params.altId,
      })
      .post("folder", params),

  getFolders: (params: GetFoldersParams) =>
    requests(SERVICE_NAME.MEDIAS_API).get("files", {
      params: {
        ...params,
        type: "folder",
        sortBy: "updatedAt",
        sortOrder: "desc",
      },
    }),

  getFiles: (folderId: string, params: GetFoldersParams) =>
    requests(SERVICE_NAME.MEDIAS_API).get("files", {
      params: {
        ...params,
        parentId: folderId,
        type: "file",
        sortBy: "updatedAt",
        sortOrder: "desc",
      },
    }),
};

export default ScreenRecorderMediaService;
